import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const GET_TASK_STATUS_LIST = 'GET_TASK_STATUS_LIST';
export const GET_AUDIT_STATUS_LIST = 'GET_AUDIT_STATUS_LIST';
export const GET_CASE_STATUS_LIST = 'GET_CASE_STATUS_LIST';

export const taskService = async (data) => {
  const options: object = {
    url:  "/api/lookup/GetStatusLookupList/TASK_STATUS" ,
    method: "GET",
    contentType: 'application/json'
  }
  const response = callMvcApi(options);
  return response;
};
export const auditService = async (data) => {
    const options: object = {
      url:  "/api/lookup/GetStatusLookupList/EXTERNAL_AUDIT_STATUS" ,
      method: "GET",
      contentType: 'application/json'
    }
    const response = callMvcApi(options);
    return response;
  };
  export const caseService = async (data) => {
    const options: object = {
      url:  "/api/lookup/GetStatusLookupList/EXTERNAL_AUDIT_CASE_STATUS" ,
      method: "GET",
      contentType: 'application/json'
    }
    const response = callMvcApi(options);
    return response;
  };

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TASK_STATUS_LIST, taskService, mock);
register(GET_AUDIT_STATUS_LIST, auditService, mock);
register(GET_CASE_STATUS_LIST, caseService, mock);

